// Auto-generated normalizer for table: Cat_Atributos
export function catAtributosNormalize(row) {
  return {
    idAtributo: row.idAtributo ?? row.IdAtributo ?? row['IdAtributo'] ?? 0,
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    tabla: row.tabla ?? row.Tabla ?? row['Tabla'] ?? '',
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['FechaCreacion'] ?? null,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
